import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { CommanSubscribeService } from "./../../../../../core/services/comman-subscribe.service";
import { COLORLIST } from "./../../../../../core/constants";
import { API } from "aws-amplify";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CONST_AWS_API } from "src/app/core/constants";
import { Subscription } from "rxjs";
import { PubNubService } from "src/app/core/services/pubnub.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/core/services/user.service";
import * as moment from "moment";
declare let $: any;

@Component({
  selector: "app-private-chat",
  templateUrl: "./private-chat.component.html",
  styleUrls: ["./private-chat.component.scss"],
})
export class PrivateChatComponent implements OnInit {
  open: boolean;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  searchContact: any = "";
  searchContactsData: any;
  userColor: any = {};
  countUserColor = 0;
  content: string = "Contacts";
  showLoader: boolean = false;
  contactsList: any;
  name: any;
  redirectTo: any = "Contacts";
  sb: any;
  //chat code starts
  isCheckingChannel: boolean = false;
  isChannelAvailable: boolean = false;
  channelHandler: any;
  openChannel: any;
  messageList: any = [];
  sendMessageText: any = "";
  contactData: any;
  groupChannel: any;
  isShowEmoji: boolean = false;
  toggleViewContact: boolean = false;
  isBlockContact: boolean = false;
  path: any;
  fansList: any = [];
  chatStatusSubscr: any;
  eventId: any;
  fansMsgData: any = [];
  msgCount: any = [];
  contactInfoSubscription: Subscription;
  contactInfo: any = {};
  openPrivateChat: boolean = false;
  groupChannels: any = [];
  userId: any;
  assets_url = environment.assets_url;
  settingsDataSubscription: Subscription;
  settingsData: any = {};

  constructor(
    private userService: UserService,
    private ngxLoader: NgxUiLoaderService,
    public router: Router,
    private route: ActivatedRoute,
    private pubnubService: PubNubService,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService
  ) { }

  ngOnInit() {
    this.userInfo = this.commonSubscribeService.userInfo;
    let key = this.route.snapshot.params.ticket_key;
    this.eventId = key.split("-");
    this.userInfo.id =
      this.userInfo && this.userInfo.id ? this.userInfo.id : this.eventId[1];
    this.getFansList();
    this.userInfoSubscription = this.commonSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        this.getFansList();
        if (
          this.router.url.includes("/stream/") ||
          this.router.url.includes("/event/schedule/")
        )
          // this.goToFansList();
          this.chatStatusSubscr = this.userService
            .getStatus()
            .subscribe((response) => {
              this.openPrivateChat = response;
              this.contactInfo = {};
              // }
              // this.content = 'Fans Online';
              this.content = "Contacts";
              this.open = true;
            });
      });
    this.contactInfo = this.commonSubscribeService.contactsData;
    this.contactInfoSubscription = this.commonSubscribeService
      .getContactInfo()
      .subscribe((response) => {
        this.contactInfo = response;
      });
    this.connectToNotificationChannel();

    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
      this.addStyle();
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
  }

  addStyle(){
    document.documentElement.style
  .setProperty('--event-private-chat-box', this.settingsData?.event_bg_primary_color);

  }
  isDataLoaded: boolean = false;
  getFansList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url = CONST_AWS_API.GET_FANS_BY_EVENT_ID + "/" + this.eventId[0];
    API.get(environment.AWS_Cognito.apiName, url, data).then(
      (response) => {
        if (response.status == 200) {
          let fansList = response["data"]["Data"];
          this.commonSubscribeService.sendSlugData(
            response["data"]["stream_info"]
          );
          (this.fansList = []), (this.msgCount = []);
          fansList.forEach((e) => {
            if (e.user_id != this.userInfo.id) {
              e.userColor = this.getColor(e);
              e.shortName = this.getName(e.name);
              if (
                e.sent &&
                e.sent.indexOf(this.userInfo.id) != -1 &&
                e.accepted.indexOf(this.userInfo.id) == -1
              ) {
                this.fansList.unshift(e);
              } else if (e.accepted.indexOf(this.userInfo.id) != -1) {
                this.fansList.unshift(e);
              } else {
                this.fansList.push(e);
              }
              if (this.fansMsgData && this.fansMsgData.length > 0) {
                this.fansMsgData.forEach((data) => {
                  this.fansList.forEach((element) => {
                    if (element.user_id == data.user_id && data.messageReceived)
                      element.messageReceived = true;
                    else element.messageReceived = false;
                    if (element.messageReceived) this.msgCount.push(element);
                    this.userService.sendMessageStatus("Private Chat");
                  });
                });
              }
            }
          });
          this.isDataLoaded = true;
          this.connectToNotificationChannel("fromFans");
          if (this.contactInfo && this.contactInfo.name) {
            this.startChat(this.contactInfo, "contact");
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getContactsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_CONTACTS_LIST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.contactsList = response["data"]["Data"];
          this.contactsList.forEach((e) => {
            e.name = e.contact_details.name;
            e.contact_details.userColor = this.getColor(e);
            e.contact_details.shortName = this.getName(e.contact_details.name);
          });
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  getColor(contact, type?) {
    let id = contact.id ? contact.id : contact.contactid;
    id = type == "chat" ? contact.userId : id;
    let color = "";
    if (!this.userColor[id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[id];
    }
    return color;
  }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  startChat(contact, from?) {
    this.toggleViewContact = false;
    setTimeout(() => {
      document.getElementById("privateMsg").style.height = "auto";
    }, 100);
    this.pubnubService.init();
    this.content = contact.name ? contact.name : contact.contact_details.name;
    if (from == "Fans Online") {
      contact.contact_details = {
        name: contact.name,
        userColor: contact.userColor,
        shortName: contact.shortName,
        profile_pic: contact.profile_pic,
      };
    }
    this.contactData = contact;
    this.contactData.disableContact = false;
    this.redirectTo = from;
    if (this.fansMsgData && this.fansMsgData.length > 0) {
      this.fansMsgData.forEach((data) => {
        if (data.user_id == contact.user_id) data.messageReceived = false;
      });
    }
    this.fansList.forEach((element) => {
      element.isActive = false;
      if (from == "contact") {
        if (element.user_id == this.contactInfo.contactid) {
          element.isActive = true;
        }
      } else {
        if (element.user_id == contact.user_id) {
          element.isActive = true;
        }
      }
      if (element.user_id == contact.user_id && element.messageReceived)
        element.messageReceived = false;
    });
    this.sortByDueDate(from);
    this.connectChannels(contact);
  }

  sendMsg(event) {
    if (event.length > 100) {
      $("#privateMsg").on("input", function () {
        // this.style.height = 'auto';
        this.style.height = this.scrollHeight + "px";
        if (this.scrollHeight > 70) {
          this.style.overflowY = "auto";
          this.style.height = "70px";
        }
      });
    } else {
      setTimeout(() => {
        document.getElementById("privateMsg").style.height = "auto";
      }, 100);
    }
  }

  connectChannels(contact) {
    this.isCheckingChannel = false;
    this.pubnubService.connect(
      this.userInfo && this.userInfo.id?.toString(),
      (success, error) => {
        if (error) {
          this.isCheckingChannel = false;
          console.log("Error while connecting chat user", error);
          this.isChannelAvailable = false;
          // this.toastr.error("Error while connecting chat user");
          return;
        } else {
          let id = contact.contactid ? contact.contactid : contact.user_id;
          let min = Math.min(this.userInfo.id, id);
          let max = Math.max(this.userInfo.id, id);
          var userIds = [this.userInfo.id, id];
          // When 'distinct' is false
          let enterGroupChannel = this.pubnubService.enterGroupChannel(userIds);
          if (enterGroupChannel) {
            this.pubnubService.enterChannel(
              min + "_" + max,
              1,
              (groupChannel, error) => {
                if (error) {
                  return;
                } else {
                  console.log("group channel", groupChannel);
                  this.groupChannel = groupChannel;
                  this.loadMessages();
                }
              }
            );
          }
        }
      }
    );

  }



  loadMessages() {
    let messages = [];
    this.pubnubService.getAllMessages(
      this.groupChannel,
      (messageList, status) => {
        if (status.error) {
          console.log("Error while loading messages", status.error);
          // this.toastr.error("Error while loading messages");
          return;
        }
        messageList.forEach((e) => {
          let localTime = moment.utc(e.createdAt).toDate();
          e.time = moment(localTime).format("hh:mm A");
          e.message = e.entry.message
          if (e.entry._sender) {
            e.entry._sender.userColor = this.getColor(e.entry._sender, "chat");
            e.entry._sender.shortName = this.getName(e.entry._sender.nickname);
            if (e.entry._sender.userId == this.userInfo.id) e.isSender = true;
          }
        });
        this.isCheckingChannel = true;
        this.messageList = messageList.filter(e => e.entry.message);;
        setTimeout(() => {
          this.setScrollBottom();
        }, 100);
      }
    );
    this.pubnubService.receiveMessages(this.groupChannel, (response) => {
      let channel = response.channel;
      let message = response.message;
      let isUniqueMessage = !this.messageList.some(
        (m) => m.messageId == message.messageId
      );
      if (
        channel &&
        this.groupChannel &&
        channel == this.groupChannel &&
        isUniqueMessage
      ) {
        message._sender.userColor = this.getColor(message, "chat");
        message._sender.shortName = this.getName(message._sender.nickname);
        let localTime = moment.utc(message.created_at).toDate();
        message.time = moment(localTime).format("hh:mm A");

        var div = document.getElementById("p-chat-inner-box");
        // Adjusted the calculation to include a buffer of 20 to ensure new messages are visible even with minor height discrepancies
        if (div && div.scrollHeight - div.scrollTop <= div.clientHeight + 20) {
          this.messageList.push(message);
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);
        } else {
          this.messageList.push(message);
        }
      }
    });
  }

  setScrollBottom() {
    var div1 = document.getElementById("pc-chat-inner-box");
    if (div1) {
      $("#pc-chat-inner-box").animate(
        {
          scrollTop: div1.scrollHeight - div1.clientHeight,
        },
        500
      );
    }
  }

  connectToNotificationChannel(message?) {
    this.pubnubService.init();
    this.pubnubService.connect(
      this.userInfo && this.userInfo.id?.toString(),
      (success, error) => {
        if (error) {
          this.isCheckingChannel = false;
          console.log("Error while connecting chat user", error);
          this.isChannelAvailable = false;
          // this.toastr.error("Error while connecting chat user");
          return;
        } else {
          this.pubnubService.enterChannel(
            "notifications",
            1,
            (openChannel, error) => {
              if (error) {
                this.isCheckingChannel = false;
                console.log("Error while connecting chat channel", error);
                this.isChannelAvailable = false;
                // this.toastr.error("Channel not available");
                return;
              }
              this.pubnubService.enterChannel(
                openChannel,
                1,
                (response, error) => {
                  if (error) {
                    console.log("Error while enter chat channel", error);
                    this.isChannelAvailable = false;
                    this.isCheckingChannel = false;
                    return;
                  }
                  this.isCheckingChannel = true;
                  this.isChannelAvailable = true;
                  this.openChannel = openChannel;
                  if (message != "fromFans") {
                    this.sendToNotificationChannel(message);
                  }
                  // if (!this.messageSubscriber) {
                  this.pubnubService.receiveMessages(
                    openChannel,
                    (response) => {
                      let membersList: any = [];
                      let channel = response.channel;
                      membersList = channel.members;
                      let message = response.message;
                      let receiverId;
                      if (message.data)
                        receiverId =
                          typeof message.data == "string"
                            ? JSON.parse(message.data)
                            : message.data;
                      if (
                        receiverId &&
                        receiverId.to &&
                        receiverId.to == this.userInfo.id
                      ) {
                        if (message._sender.userId) {
                          this.fansList.forEach((element) => {
                            if (
                              element.user_id == message._sender.userId ||
                              element.messageReceived
                            )
                              element.messageReceived = true;
                            else element.messageReceived = false;
                          });
                        }
                      } else {
                        if (membersList && membersList.length > 0) {
                          membersList.forEach((mem) => {
                            this.fansList.forEach((element) => {
                              if (
                                mem.userId == element.user_id ||
                                element.messageReceived
                              )
                                element.messageReceived = true;
                              else element.messageReceived = false;
                              if (element.messageReceived) {
                                this.msgCount.push(element);
                                this.userService.sendMessageStatus(
                                  "Private Chat"
                                );
                              }
                            });
                          });
                        }
                      }
                      this.fansMsgData = this.fansList;
                    }
                  );
                }
              );
            }
          );
        }
      }
    );
  }

  getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }

  sortByDueDate(from?): void {
    this.fansList.sort((a: any, b: any) => {
      return <any>b.created_time - <any>a.created_time;
    });
    // if (from == 'contact') {
    //   const activeIndex = this.fansList.findIndex(e => e.isActive);
    //   this.fansList.push(...this.fansList.splice(0, activeIndex));
    // }
  }

  sendToNotificationChannel(message) {
    if (!this.openChannel) {
      this.toastr.error("Chat channels not connected");
      return;
    }

    let sendMessageText = message;
    if (sendMessageText) {
      const params: any = {};
      params.message = sendMessageText;
      params.messageId = Date.now();
      params.data = {
        to: this.contactData.user_id,
      };
      params._sender = {
        profileUrl: this.userInfo.profie_pic || "",
        userId: this.userInfo.id,
        nickname: this.userInfo.user_display_name,
      };
      params.data = JSON.stringify(params.data);
      params.customType = "CUSTOM_TYPE";
      this.pubnubService.sendMessage(
        this.openChannel,
        params,
        (status, response) => {
          if (status.error) {
            console.log("Error while sending message", status);
            this.toastr.error("Error while sending message");
            return;
          }
          sendMessageText = "";
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);
        }
      );
    }
  }

  openCloseEmoji() {
    this.isShowEmoji = !this.isShowEmoji;
  }
  addEmoji(event) {
    if (event.emoji && event.emoji.native) {
      this.sendMessageText += " " + event.emoji.native;
      // this.isShowEmoji = false;
    }
  }

  sendMessage() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Message sent in private chat of stream ${streamId} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `A Message was sent in private chat of stream ${streamId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    if (!this.groupChannel) {
      this.toastr.error("Chat channels not connected");
      return;
    }

    let sendMessageText = this.sendMessageText,
      sentMessage = this.sendMessageText;
    setTimeout(() => {
      this.sendMessageText = "";
    }, 10);

    if (sendMessageText) {
      setTimeout(() => {
        document.getElementById("privateMsg").style.height = "auto";
      }, 100);
      const params: any = {};
      params.message = sendMessageText;
      params.customType = "CUSTOM_TYPE";
      params.messageId = Date.now();
      params._sender = {
        isSender: true,
        profileUrl: this.userInfo.profie_pic || "",
        userId: this.userInfo.id,
        nickname: this.userInfo.user_display_name,
      };
      console.log("pubnub params", params, this.groupChannel)
      this.pubnubService.sendMessage(
        this.groupChannel,
        params,
        (status, response) => {
          let userMessage = response.message;
          if (status.error) {
            console.log("Error while sending message", status);
            this.toastr.error("Error while sending message");
            return;
          }
          sendMessageText = "";
          this.isShowEmoji = false;
          userMessage._sender.userColor = this.getColor(userMessage, "chat");
          userMessage._sender.shortName = this.getName(
            userMessage._sender.nickname
          );
          // this.userService.sendChatMessage(userMessage);
          userMessage.isSender = true;
          let localTime = moment.utc(response.timeToken).toDate();
          userMessage.time = moment(localTime).format("hh:mm A");
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);

          this.connectToNotificationChannel(sentMessage);
        }
      );
    }
  }

  viewContact(from?) {
    this.toggleViewContact = !this.toggleViewContact;
    this.getSelectedContactDetails();
  }

  getSelectedContactDetails() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url =
      CONST_AWS_API.GET_CONTACT_DETAILS + "/" + this.contactData.user_id;
    API.get(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          let contactData = response["data"]["Data"];
          this.contactData.contact_details = {
            email: contactData.email,
            phone_number: contactData.user_phone_number,
            profile_pic: contactData.profile_pic,
            name: contactData.user_display_name,
            userColor: this.contactData.userColor,
            shortName: this.contactData.shortName,
          };
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  clearChatHistory() {
    this.groupChannel.resetMyHistory((response, error) => {
      if (error) {
        return;
      }
      this.messageList = [];
    });
    this.getFansList();
  }

  backToContact() {
    this.toggleViewContact = !this.toggleViewContact;
    setTimeout(() => {
      this.setScrollBottom();
    }, 100);
  }

  sendRequest(contact) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        event_id: this.eventId[0],
        from: this.userInfo.id,
        to: contact.user_id,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.SEND_EVENT_CONTACT_REQUEST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.toastr.success("Request sent successfully");
          this.contactData.disableContact = true;
          this.getFansList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  ngOnDestroy() {
    this.pubnubService.disconnect([this.groupChannel, "notifications"]);
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.contactInfoSubscription)
      this.contactInfoSubscription.unsubscribe();
  }
}